import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AddressEffects, addressReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([AddressEffects]), StoreModule.forFeature(`address`, addressReducer)]
})
export class AddressStateModule {}
